
import React from 'react';
import { useStore } from '../hooks/useStore.ts';
import { api } from '../services/api.ts';
import { Gavel, Clock, User, ShieldCheck } from 'lucide-react';

export const AuditLedger: React.FC<{ projectId: number }> = ({ projectId }) => {
  const logs = useStore(() => api.auditLogs.list(l => l.projectId === projectId), [projectId], 'auditLogs') || [];

  return (
    <div className="space-y-6 max-w-4xl mx-auto py-12">
      <div className="flex items-center gap-4 mb-10 px-4">
        <div className="p-3 bg-black rounded-2xl text-white shadow-xl"><Gavel size={24}/></div>
        <div>
          <h3 className="text-2xl font-black text-black tracking-tight uppercase leading-none">Immutable Audit Trail</h3>
          <p className="text-[10px] font-black text-zinc-400 uppercase tracking-widest mt-2">Compliance Log: "Golden Thread" History</p>
        </div>
      </div>

      <div className="bg-white rounded-[3rem] border border-zinc-200 overflow-hidden shadow-sm">
        <div className="divide-y divide-zinc-50">
          {logs.sort((a,b) => new Date(b.createdAt!).getTime() - new Date(a.createdAt!).getTime()).map(log => (
            <div key={log.id} className="p-8 flex items-start gap-8 hover:bg-zinc-50/50 transition-colors">
              <div className="pt-1">
                <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-400">
                  <ShieldCheck size={16}/>
                </div>
              </div>
              <div className="flex-1">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="text-sm font-black text-black uppercase tracking-tight">{log.action}</h4>
                  <div className="flex items-center gap-2 text-[9px] font-black text-zinc-300 uppercase tracking-widest">
                    <Clock size={10}/>
                    {new Date(log.createdAt!).toLocaleString()}
                  </div>
                </div>
                <p className="text-xs text-zinc-500 font-bold leading-relaxed mb-3">"{log.details}"</p>
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <User size={10} className="text-zinc-400"/>
                    <span className="text-[9px] font-black uppercase tracking-widest text-zinc-400">{log.createdBy}</span>
                  </div>
                  <span className="text-[9px] font-black uppercase tracking-widest text-zinc-200">ID: {log.entityType}-{log.entityId}</span>
                </div>
              </div>
            </div>
          ))}
          {logs.length === 0 && (
            <div className="p-20 text-center text-zinc-300 uppercase font-black text-[10px] tracking-[0.3em]">
               Baseline Audit Trail Empty
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
